<template>
  <div class="event-downloads row">
    <template v-if="attached.length > 0">
      <div class="col-12 multi-assign-values">
        <a
          v-for="(item, i) in attached"
          :key="i"
          class="pill"
          href="#"
          @click.prevent="remove(i)"
        >
          <span class="text">{{ item.filename }}</span>
          <icon icon="remove" class="icon" />
          <input
            type="hidden"
            :name="`downloads[${i}][filename]`"
            :value="item.filename"
          />
          <input
            type="hidden"
            :name="`downloads[${i}][managers_only]`"
            :value="!!item.managers_only ? 1 : 0"
          />
        </a>
      </div>
    </template>

    <template v-for="(item, i) in uploaded">
      <div :key="`uploader_${i}`" class="col-12 mb-3">
        <FileUpload
          :id="`event-download-uploader-${i}`"
          :url="route('event-request.upload', { course: course.id })"
          @uploaded="fileUploaded"
        />
        <input
          type="hidden"
          :name="`downloads[${i}][filename]`"
          :value="item.filename"
        />
      </div>
      <div :key="`checkbox_${i}`" class="col-12 mb-3">
        <Field
          type="checkbox"
          :name="`downloads[${i}][managers_only]`"
          :id="`event-download-checkbox-${i}`"
          label="Distributor Employees Only"
          :value="item.managers_only"
          :checkbox-value="1"
        />
      </div>
    </template>

    <div class="col-12 text-center text-lg-left">
      <a class="btn btn-info" href="#" @click.prevent="add()"
        >Add Another File</a
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    course: { type: Object, required: true },
    downloads: { type: Array, default: () => [] },
  },
  data() {
    return {
      attached: [],
      uploaded: [],
    };
  },
  watch: {},
  methods: {
    add() {
      this.uploaded.push({
        filename: null,
        managers_only: false,
      });
    },
    remove(index) {
      this.attached.splice(index);
    },
    fileUploaded(file, response, id) {
      var index = parseInt(id.replace("event-download-uploader-", ""), 10);
      this.uploaded[index].filename = response.file;
    },
  },
  mounted() {
    this.attached = _.cloneDeep(this.downloads);
    this.add();
  },
};
</script>